<template>
    <div class="app-settings-dialog">

        <v-dialog 
        v-model="value" 
        @input="onCloseDlg" 
        max-width="400px"> 

            <v-card class="app-settings_panel" >
                <v-card-title class="headline grey lighten-2 pr-0" primary-title v-if="user != null" >
                    <v-avatar class="avatar-head blue-grey darken-2 orange--text">
                        <span >{{ user.name[0] }}</span>
                    </v-avatar>
                    <v-card-text class="head-line-content">
                        <div class="head-line-content_organization">
                            {{ user.organization }}
                        </div>
                        <div class="line-value">
                            <span class="title-value grey--text text--darken-1">Name:</span>{{ user.name }}
                        </div>
                        <div class="line-value">
                            <span class="title-value grey--text text--darken-1">Role:</span>{{ user.role }}
                        </div>
                        <div class="line-value">
                            <span class="title-value grey--text text--darken-1">E-mail:</span>{{ user.email }}
                        </div>
                    </v-card-text>

                </v-card-title>

            <v-container>
                <v-row class="mb-2 ma-2">
                    <v-icon class="item-info-icon" medium color="blue-grey lighten-2">supervised_user_circle</v-icon>
                    <v-btn text @click="showUserPreferences()">{{communication_preferences}}</v-btn>
                </v-row>
                <v-row class="mb-2 ma-2" v-if="isSystemAdmin">
                    <v-icon class="item-info-icon" medium color="blue-grey lighten-2">mdi-account-multiple</v-icon>
                    <v-btn text @click="showAdminGroupsPage()">{{admin_groups}}</v-btn>
                </v-row> 
            </v-container>               

                <v-divider class="divider"></v-divider>

                <v-card-actions>
                    <v-text
                    class="currentVersionLabel"
                    v-if="local_isSystemAdmin"
                    >Build: {{user.buildVersion}}</v-text>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="orange--text"
                        text
                        @click="onActionDlgLogout">
                        LogOut
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import {EventBus} from '../main'

    export default {
        name: "app-settings-dialog",
        props: ["value"],
       
        data() {
            return {
                local_showSettingsDialog: this.showSettingsDialog,
                show_user_preferences_dialog: false,
                user_preferences_details: null,
                local_user_preferences_details:{
                    urgentCommunications: false,
                    dataAvailabilityDelays: false,
                    generalCommunications: false,
                    newReleaseAnnouncements: false,
                    systemDowntime: false,
                    dataQuality: false
                },
                user_action: [
                    {
                        icon: "supervised_user_circle",
                        title: "Communication Preferences",
                    },
                    {
                        icon: "mdi-account-multiple",
                        title: "Admin Groups",
                    }
                ],
                admin_groups: "Admin Groups",
                communication_preferences: "Communication Preferences",
                show_admin_groups_dlg: false,
                adminsList: null,
                internalUsers: null,
                local_isSystemAdmin: this.$store.getters.getIsSystemAdmin
            };
        },
        computed: {
            user() {
                return this.$store.getters.getUserInfo;
            },
             isSystemAdmin(){
                return this.$store.getters.getIsSystemAdmin;
            },
        },
        created(){        
            EventBus.$on('renderAdminGroups', () =>{
                this.getAdmins();
                this.getInternalUsers();
            });
            
            EventBus.$on("onCloseAdminGroupsDialog", () => {
                this.onCloseAdminGroupsDlg();
            })
        },
        methods: {
            initialize() {},
            onActionDlgItemClick(item) {
                console.log("onActionDlgItemClick(item)", item);
                this.show_user_preferences_dialog = true;
            },
            async showUserPreferences(){
                console.log("inside showUserPreferences() method");                
                this.user_preferences_details = await this.getUserPreferencesDetails();
                console.log("loading user preferences");                
                this.local_user_preferences_details.urgentCommunications = this.user_preferences_details.urgentCommunications;
                this.local_user_preferences_details.dataAvailabilityDelays = this.user_preferences_details.dataAvailabilityDelays;
                this.local_user_preferences_details.generalCommunications = this.user_preferences_details.generalCommunications;
                this.local_user_preferences_details.newReleaseAnnouncements = this.user_preferences_details.newReleaseAnnouncements;
                this.local_user_preferences_details.systemDowntime = this.user_preferences_details.systemDowntime;
                this.local_user_preferences_details.dataQuality = this.user_preferences_details.dataQuality;
                this.show_user_preferences_dialog = true;
                this.$emit("showUserPreferenceDialog", {user_preferences_dlg:true, user_preferences_details:this.local_user_preferences_details});
            },
            async showAdminGroupsPage(){
                if(this.adminsList == null){
                    await this.getAdmins();
                }
                if(this.internalUsers == null){
                    await this.getInternalUsers();
                }
                this.$emit("showAdminGroupsPage", {admin_dlg:true, admin_list:this.adminsList, internal_users:this.internalUsers});
            },
            onActionDlgLogout() {
                this.$emit("logout");
            },
            onCloseDlg(){
                this.$emit("input", false);
            },
            onCloseAdminGroupsDlg(){
                this.show_admin_groups_dlg = false;
            },            
            async getUserPreferencesDetails(){
                const userId = this.$store.getters.getUserId;
                const response = await this.$store.dispatch("getUserPreferences",userId);                
                if(typeof response == "undefined"){
                    console.log("No value present for userId: "+userId);
                    return null;
                }else{
                    console.log(response);
                    return response;
                }
            },

            async getAdmins(){
                console.log("inside getAdmins() method");
                const response = await this.$store.dispatch("getAdminGroups");                
                if(typeof response == "undefined"){
                    console.log("response is null");
                    return null;
                }else{
                    this.adminsList = response;
                    return response;
                }
            },

            async getInternalUsers(){
                console.log("inside getInternalUsers() method");
                const response = await this.$store.dispatch("getInternalUsers");                
                if(typeof response == "undefined"){
                    console.log("response is null");
                    return null;
                }else{
                    this.internalUsers = response;
                    return response;
                }
            }           
        }
    };
</script>

<style lang="scss">
    .app-settings-dialog {
        //overflow-y: hidden;
        height: 100%;
    }

    .app-settings_panel {
        position: absolute !important;
        width: 400px !important;
        top: 51px;
        right: 30px !important;

        .menu-users {
            margin-left: 9px;
            margin-top: -9px;
            width: 24%;

            .v-select__slot {
                font-size: 15px;
            }
        }

        .head-line-content {
            margin-left: 52px;
            margin-top: -90px;
            margin-right: 0px;
            padding-right: 0px;

            .line-value {
                margin-top: -7px;
                font-size: 15px;
                margin-right: 0px;
                padding-right: 0px;

                .title-value {
                    display: inline-block;
                    text-align: end;
                    margin-right: 5px;
                    font-size: 14px;
                    min-width: 43px;
                }
            }
        }

        .avatar-head {
            margin-top: 36px;
        }

        .head-line-content_organization {
            font-size: 17px;
            font-weight: bold;
            margin-bottom: 9px;
        }

        .list-user-action {
            display: block;

            .item-user-action-tile {
                margin-bottom: -9px;

                .item-info-icon {
                    //margin-left: -18px;
                }
            }
        }

        .divider {
            margin-top: 9px;
        }

        .expansion-panel-items {
            .v-expansion-panel__container {
                .v-expansion-panel__header {
                    padding-right: 18px;
                }
            }

            .expansion-panel-item-content {
                margin-top: 9px;
                display: flex;

                .expansion-panel-item-icon {
                    margin-left: -11px;
                }

                .expansion-panel-item-txt {
                    margin-left: 30px;
                    margin-top: 3px;
                }
            }

            .profile-content {
                width: 90%;
                text-align: center;
                margin-left: 5%;
                margin-top: -3%;

                .profile-content_item {
                    margin-top: -6px;
                }
            }
        }

        .close-btn-dlg-icon {
            margin-top: 6px;
        }
    }

    .list-group-actions {
        padding: 0;

        .list-group-actions_item {
            margin-top: -9px;
        }

        .v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {
            color: #f57c00; // accent
        }
    }

    .currentVersionLabel{
        font-size: 11px;
        color: orange;
    }
</style>
